import {
  CellExportFormats,
} from '../xlsxExport.constants';

import numberFormatBuilder from './numberFormatBuilder';

const exportFormatsToCustomFormats = (
  exportFormat,
  {
    hideDecimals = false,
    negativeMinus = true,
    shouldDisplayZero = true,
  } = {}
) =>
  ({
    [CellExportFormats.CUSTOM_TEXT]: null,
    [CellExportFormats.NUMBER]: numberFormatBuilder({
      hideDecimals,
      negativeMinus,
      shouldDisplayZero,
    }),
    [CellExportFormats.PERCENT_2]: numberFormatBuilder({
      percentage: true,
      numberOfDecimalPlaces: 2,
      hideDecimals,
      negativeMinus,
      shouldDisplayZero,
    }),
    [CellExportFormats.PERCENT_6]: numberFormatBuilder({
      percentage: true,
      numberOfDecimalPlaces: 6,
      hideDecimals,
      negativeMinus,
      shouldDisplayZero,
    }),
    [CellExportFormats.PERCENT_4]: numberFormatBuilder({
      percentage: true,
      hideDecimals,
      negativeMinus,
      shouldDisplayZero,
    }),
  }[exportFormat] || null);

export default exportFormatsToCustomFormats;
